export default __webpack_public_path__ + "static/media/diamonds.81f06f8e.png";